import { useEffect, useState } from "react";

const useBreakpoint = (query: string): boolean => {
	const [queryMatch, setQueryMatch] = useState(false);

	useEffect(() => {
		const mql = window.matchMedia(query);

		// To check whether event listener is attached or not
		let isAttached = false;

		const handleQueryListener = () => {
			setQueryMatch(mql.matches);
		};

		if (window && window.matchMedia(query)) {
			setQueryMatch(mql.matches);
			isAttached = true;
			mql.addListener(handleQueryListener);
		}

		return () => {
			if (isAttached) {
				mql.removeListener(handleQueryListener);
			}
		};
	}, [query]);

	return queryMatch;
};

export default useBreakpoint;
